/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

//Jacques Bega
//hook that obtains subject property information
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { fetchQIDByKeyword } from '../queryFunctions';

const useQIDByKeyword = (token: string, qid: string, keyword: string) => {
  return useQuery({
    queryKey: [token, qid, keyword, 'qidByKeyword'],
    queryFn: ({ signal }: QueryFunctionContext) => fetchQIDByKeyword(signal, token, qid, keyword),
    refetchOnWindowFocus: false,
  });
};

export default useQIDByKeyword;
